import { Modal, Button, Form, Col, Row, Container, FormCheck  } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import '../../assets/Styles/CancelTripCSS/CancelTripCSS.css';
// import ConfirmationModal from '../Controls/ConfirmationModal';
import APICom from '../../utils/helpers/APICom';
import PersistStorage from '../../utils/helpers/PersistStorage';


const CancelTrip = (data) => {
  
  /////////////////////////////////////////////////////  CANCEL COMPONENT HOOKS ///////////////////////////////////////////////////////
  const cancelReasonRef = useRef();
  const cancelCommentRef = useRef();
  const chkReturnTripRef = useRef(null);
  const [isComponentLoading, setIsComponentLoading] = useState(true);
  const [TableHeaders, setTableHeaders] = useState(["Select","Confirmation#","Pickup Person","Trip Status", "Return Trip"]);
  const [tripsInfo, setTripsInfo] = useState({});
  const [TripSelection, setTripSelection] = useState([]);
  const [showTripTable, setShowTripTable] = useState(false);
  // const isInitialRenderEmptyDependancy = useRef(true); 
  // const isInitialRenderWithDependancy = useRef(true);

  // Fetching Cancel Reason for Dropdown
  const { CancelReasonData, ASCSSettingData } = useSelector((store) => store.combinedata);
  const { loginData }  = useSelector((store) => store.login);

  //useState for CancelTrip Component
  const [cancelTripObj, setCancelTripObj] = useState({iSRATSPID:'', ServiceID:'',TripRequestStatus:'', iAssignedVehicleId:'-1',
  iScheduleID:'-1',AssignedDriverId:'-1',ConfirmationNo:'',PickupPerson:'', PZONE:'',IsReturnTrip:'false',TableSource: '', ServiceStatus: '',
  iSchDetailID: '-1', CancelTripConf: '', CancelTripPickPerson:''});

  //useState for Confirmation Modal
  const [confirmationModal, setConfirmationModal] = useState({btnOkText: 'Ok', btnCancelText:'Cancel', show: false, title: '', body: '', msgType:''});

  //Cancel Dialog Options & Alert Modal useStates
  const [cancelReasons, setCancelReasons] = useState([]);
  // const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showCancelAlert, setShowCancelAlert] = useState(false);
  const [cancelAlert, setCancelAlert] = useState({alertTitle: '', alertMsg:''});
  // const [forceCancel, setForceCancel] = useState(false);
  const [IsReturnTrip, setIsReturnTrip] = useState("false");
  const [showTripStatus, setShowTripStatus] = useState(false);
  const [chkReturnTripVisible, setchkReturnTripVisible] = useState(false);
  const [isReturnTripCheckBox, setIsReturnTripChecBox] = useState(false);
  
  const [showConfirmationPromptForReturnCanNS, setShowConfirmationPromptForReturnCanNS] = useState(false);
  const [confirmationPromptForReturnCanNSAlert, setConfirmationPromptForReturnCanNSAlert] = useState({alertTitle: '', alertMsg:''});
  const isReturnCanNSRef = useRef(false);

  const [promptForReturnCanNS, setPromptForReturnCanNS] = useState(true);


  const [affSelected, setAffSelected] = useState(-1);
                                                          

  useEffect(() => {
    if(ASCSSettingData !== null && ASCSSettingData !== undefined)
    {
      let iAffiliateID = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
      if(iAffiliateID !== undefined && iAffiliateID !== ""){
        iAffiliateID = parseInt(iAffiliateID);
        setAffSelected(iAffiliateID);
      }
        if (ASCSSettingData.hasOwnProperty(iAffiliateID)) {
          const ascsSettingDataByAffiliate = JSON.parse(ASCSSettingData[iAffiliateID]); // Parse JSON string into an array
          for(let i=0; i < ascsSettingDataByAffiliate.length; i++)
          {
                if(ascsSettingDataByAffiliate[i]["SubTitle"] === "PromptForReturnCanNS")
                {
                  setPromptForReturnCanNS(
                    String(ascsSettingDataByAffiliate[i]["value"]).toLowerCase() === "true"
                  );
                  break;
                }
          }
        }
    }
  }, [ASCSSettingData]);
    


  // Cancel Trip Component Load
  useEffect(() => {
    try{
      if(data.GridRowData === null || data.GridRowData.length <= 0)
      {
        setCancelAlert({...cancelAlert, alertTitle: 'No trip selected', alertMsg:'Please select a trip to cancel.'});
        setShowCancelAlert(true);
      } 
      else if(data.GridRowData.length > 1)
      {
        setTripsInfo(data.GridRowData);
        let tripListPos = [];
        let dict = {};
        for(let i = 0; i < data.GridRowData.length; i++)
        {
          let confirm = (data.GridRowData[i].ConfirmationNo ? data.GridRowData[i].ConfirmationNo : data.GridRowData[i]["Confirmation #"]);
          dict = {};
          dict[confirm] = 1;
          tripListPos.push(dict);
        }
        setTripSelection(tripListPos);
        setShowTripTable(true);
        setchkReturnTripVisible(false);
        // let gData = [];
        // let serviceIDList = "";
        
        // setCancelAlert({...cancelAlert, alertTitle: 'Cancel Trip Alert', alertMsg:'This feature is a work in progress.'});
        // setShowCancelAlert(true);
        // updateCancelTripComponentStateObjects("cancelTripObj", {...cancelTripObj, iSRATSPID:gData[0].iSRATSPID, ServiceID:gData.ServiceID,TripRequestStatus:gData.TripRequestStatus, PickupPerson:gData.PickupPerson,
        //   iAssignedVehicleId:(gData.iAssignedVehicleId === undefined || gData.iAssignedVehicleId === null)?'-1':gData.iAssignedVehicleId, iScheduleID:(gData.iScheduleID === undefined|| gData.iScheduleID === null)?'-1': gData.iScheduleID,
        //   AssignedDriverId:(gData.AssignedDriverId === undefined || gData.iAssignedVehicleId === null)?'-1':gData.AssignedDriverId,ConfirmationNo:gData.ConfirmationNo, 
        //   PZONE:gData.PZONE,TableSource: gData.TableSource, ServiceStatus: gData.ServiceStatus, iSchDetailID: (gData.iSchDetailID == undefined || gData.iAssignedVehicleId === null)?'-1':gData.iSchDetailID,
        //   CancelTripConf: gData.ConfirmationNo, CancelTripPickPerson : gData.PickupPerson});
        // setIsReturnTrip(((gData[0].IsReturnTrip === "")?"false":(gData[0].IsReturnTrip?"true":"false")));
      }
      else{
        const gData = data.GridRowData[0];
        let confirm = (gData.ConfirmationNo ? gData.ConfirmationNo : gData["Confirmation #"]);
        let tripReqStatus = (gData.TripRequestStatus ? gData.TripRequestStatus : "");
        let serviceID = (gData.ServiceID ? String(gData.ServiceID) : String(gData.iScheduleID));
        if(serviceID === undefined || serviceID === "null" || serviceID === "-1" || serviceID === ""){
          serviceID = "-1";
        }
        updateCancelTripComponentStateObjects("cancelTripObj", {...cancelTripObj, iSRATSPID:String(gData.iSRATSPID), ServiceID:serviceID,
          TripRequestStatus:tripReqStatus, PickupPerson:gData.PickupPerson,
          iAssignedVehicleId:(gData.iAssignedVehicleId === undefined || gData.iAssignedVehicleId === null)?'-1':String(gData.iAssignedVehicleId), 
          iScheduleID:(gData.iScheduleID === undefined|| gData.iScheduleID === null)?'-1': String(gData.iScheduleID),
          AssignedDriverId:(gData.AssignedDriverId === undefined || gData.AssignedDriverId === null)?'-1':String(gData.AssignedDriverId), ConfirmationNo:confirm, 
          PZONE:gData.PZONE,TableSource: (gData.TableSource ? gData.TableSource : "FromScheduleTable"), ServiceStatus: gData.ServiceStatus, 
          iSchDetailID: (gData.iSchDetailID == undefined || gData.iSchDetailID === null)?'-1':gData.iSchDetailID,
          CancelTripConf: confirm, CancelTripPickPerson : gData.PickupPerson});
        setIsReturnTrip(((String(gData.IsReturnTrip).toLowerCase() === "")?false:(String(gData.IsReturnTrip).toLowerCase() === "true"?true:false)));
      }
    }
    catch(err){console.log(err);}

  },[]);
 

  useEffect(() => {
    // if (isInitialRenderWithDependancy.current) {
    //   isInitialRenderWithDependancy.current = false;
    //   return;
    // }
    // if (isInitialRenderWithDependancy.current === false && isInitialRenderEmptyDependancy.current) {
    //   isInitialRenderEmptyDependancy.current = false;
    //   return;
    // }
    if(isComponentLoading)
    {
      setIsComponentLoading(false);
      return;
    }

    CancelTripFromARQPRQSRQ();

  }, [IsReturnTrip]);


  /////////////////////////////////////////////////////  CANCEL COMPONENT HOOKS ///////////////////////////////////////////////////////
   
  /////////////////////////////////////////////////////  STATE UPDATE ENGINE SWITCH ///////////////////////////////////////////////////
  const updateCancelTripComponentStateObjects = (stateObj, newValues) => {
    switch (stateObj) {
      case "cancelTripObj":
        setCancelTripObj((prevCancelTripObj) => ({
          ...prevCancelTripObj,
          ...newValues
        }));
        break;
      // case "confirmationModal":
      //   setConfirmationModal((prevconfirmationModal) => ({
      //     ...prevconfirmationModal,
      //     ...newValues
      //   }));
      //   break;  
      default:
        break;
    }
  };
 /////////////////////////////////////////////////////  STATE UPDATE ENGINE SWITCH ///////////////////////////////////////////////////

  function CancelTripFromARQPRQSRQ()
  {
    try{
      if (cancelTripObj.CreatedBy === "(ExternalDispatch)") {
        setCancelAlert({...cancelAlert, alertTitle: 'Trip cancel restricted', alertMsg:'This is a broker trip, cancel not allowed!'});
        setShowCancelAlert(true);
        return false;
      }
  
      if (cancelTripObj.TripRequestStatus && cancelTripObj.TripRequestStatus.toLowerCase() === "pickedup") {
        setShowTripStatus(true);
      }
      if(IsReturnTrip && String(IsReturnTrip).toLowerCase() === "true")
      {
        setchkReturnTripVisible(true);
        setIsReturnTripChecBox(true);
      }
      else
      {
        setchkReturnTripVisible(true);
        setIsReturnTripChecBox(false);
      }
  
      data.setShowCancel(true);
    }
    catch(err){console.log(err);}
    
    
    // if (forceCancel === false && cancelTripObj.TripRequestStatus.toLocaleLowerCase() === "pickedup") {
    //       updateCancelTripComponentStateObjects("confirmationModal", {...confirmationModal, 
    //       show: true, title: `Confirm Cancel : '${data.GridRowData.ConfirmationNo}'`,
    //       body: `Confirmation# '${data.GridRowData.ConfirmationNo}' and pickup person '${data.GridRowData.PickupPerson}', has already been marked as Picked-Up. Would you still like to mark it as Cancel?`,
    //       msgType:'pickeduptrip'});
    //       return;
    // }else{
    //   if (IsReturnTrip.toLocaleLowerCase() === "true") {
    //     updateCancelTripComponentStateObjects("confirmationModal", {...confirmationModal, btnOkText: 'Yes', btnCancelText: 'No',
    //       show: true, title: `Confirm Cancel : '${data.GridRowData.ConfirmationNo}'`,
    //       body: `Confirmation# '${data.GridRowData.ConfirmationNo}', and Pickup Person ' ${data.GridRowData.PickupPerson}', also has return leg(s).
    //       Please click 'YES' to cancel this trip along with all return legs?
    //       Click 'No' to cancel only selected trip.`,
    //       msgType:'isreturntrip'});
    //       return;
    //   }
    //   else
    //   {
    //     setShowCancelDialog(true);
    //   }
    // }
  }

  
  
  ////////////////////////////////////////////////////// CANCEL DIALOG EVENTS //////////////////////////////////////////////////

   //Loading cancel reason dropdown by affiliate 
   const LoadingCancelReasonByAffiliate = () => {
    try{
      if(data.GridRowData.length !== 0)
      {
        // console.log(CancelReasonData);
        const cancelReasonJSON = (CancelReasonData ? ((CancelReasonData[parseInt(data.GridRowData[0].iSRATSPID)] !==  undefined 
          && data.GridRowData[0].iSRATSPID)? JSON.parse(CancelReasonData[parseInt(data.GridRowData[0].iSRATSPID)]): undefined) : undefined);
        
        if(cancelReasonJSON !== undefined && cancelReasonJSON && Array.isArray(cancelReasonJSON) && cancelReasonJSON.length > 0){
            const cancelReasonByAffiliate = [];
            //cancelReasonByAffiliate.push({"name": "Select reason ...", "id": -1, "description": "" });
            cancelReasonJSON.map((item) => {
              return cancelReasonByAffiliate.push({"name": item.vTitle, "id": item.iId, "description": item.vDescription });
            })
            if(cancelReasonByAffiliate.length > 0)
            {
              setCancelReasons(cancelReasonByAffiliate);
            }
        }
        else if(data.GridRowData[0].TripRequestStatus && data.GridRowData[0].TripRequestStatus.toUpperCase() === "CANCELLLED")
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Cancel Reasons', alertMsg:'Selected Trip is already cancelled!'});
          setShowCancelAlert(true);
          return false;
        }
        else{
          setCancelAlert({...cancelAlert, alertTitle: 'Cancel Reasons', alertMsg:'Cancel reason not loading!'});
          setShowCancelAlert(true);
          return false;
        }
      }
      
    }
    catch(err){console.log(err);}
    
  }

  const OpenCancelDialg = ()=> { 
    LoadingCancelReasonByAffiliate();
  }

  const handleReturnTripCheckBox = () => {
    setIsReturnTripChecBox(prevValue => !prevValue);
  }

  const handleCancelReasonChange = (e) => {
    const iTem = cancelReasons.find((item) => {
      return (item.id === Number(e.target.value)) 
    })
    if(iTem)
      cancelCommentRef.current.value = iTem.description;
  }

  const waitForUserConfirmation = (alertMsgText) => {
    return new Promise((resolve) => {
      setConfirmationPromptForReturnCanNSAlert({
        alertMsg: alertMsgText,
        onConfirm: () => {
           
          isReturnCanNSRef.current = true;
          setShowConfirmationPromptForReturnCanNS(false);
          resolve(true);
        },
        onCancel: () =>{
           
          isReturnCanNSRef.current = false;
          setShowConfirmationPromptForReturnCanNS(false);
          resolve(true);
        },
        onOk: () =>{
           
          isReturnCanNSRef.current = false;
          setShowConfirmationPromptForReturnCanNS(false);
          resolve(true);
        } 
      });
      setShowConfirmationPromptForReturnCanNS(true);
    });
  };

  const handleCancelDialogOK = async() => {
    
    // if(false)
    // {
    //   setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'Trip already Dispatched! Trip not available to cancel.'});
    //   setShowCancelAlert(true);
    //   return false;
    // }
    // console.log(data.GridRowData);
    try{
      if(data.GridRowData.length > 1)
      {
        
        let tempArr = [];
        let confirmationFlag = false;
        for(let y in TripSelection)
        {
          tempArr.push(Object.values(TripSelection[y])[0]);
        }
        
        if(tempArr.indexOf(1) > -1)
        {
          
          //Confirmation Section for Return Trip Cancellation
          //----------------------------------------------------------------
          const hasAtLeastOneSelectionChecked = tempArr.some(item => item === 1);
          if(hasAtLeastOneSelectionChecked){
            const hasAtLeastOneReturnTrip = data.GridRowData.some(
              item => String(item?.IsReturnTrip).toLowerCase() === "true"
            );
            if(hasAtLeastOneReturnTrip === true){
              
                isReturnCanNSRef.current = false;
                if(promptForReturnCanNS){
                  const userConfirmed = await waitForUserConfirmation("Do you want to cancel the return trip(s) as well?");

                  if (!userConfirmed) return;
                }
                else
                {
                    const userConfirmed = await waitForUserConfirmation("There is a return trip of this rider, Please take care of that manually.");

                    if (!userConfirmed) return;
                    isReturnCanNSRef.current = false;
                 
                }
            }
          }
          //----------------------------------------------------------------
          //Confirmation Section for Return Trip Cancellation

          let Queue = "";
          for(let k = 0; k < data.GridRowData.length; k++)
          {
            let confirm = (data.GridRowData[k].ConfirmationNo ? data.GridRowData[k].ConfirmationNo : data.GridRowData[k]["Confirmation #"]);
            let tripStatus = (data.GridRowData[k].TripRequestStatus ? data.GridRowData[k].TripRequestStatus : "");
            if(TripSelection[k][confirm] === 1)
            {
              if (data.GridRowData[k].TableSource && (data.GridRowData[k].TripRequestStatus.toLowerCase() === "accepted" || data.GridRowData[k].TripRequestStatus.toLowerCase() === "dispatched" 
                || data.GridRowData[k].TripRequestStatus.toLowerCase() === "irtpu" || data.GridRowData[k].TripRequestStatus.toLowerCase() === "atlocation" 
                || data.GridRowData[k].TripRequestStatus.toLowerCase() === "pickedup") && (data.GridRowData[k].TableSource && data.GridRowData[k].TableSource !== "FromScheduleTable"))
                {
                  Queue = "InProgress";
                }
              else if (data.GridRowData[k].TableSource && data.GridRowData[k].TableSource === "FromScheduleTable"){
                Queue = "Scheduled";
              }
              else{
                Queue = (data.GridRowData[k].TableSource ? "OnDemand" : "Scheduled");
              }


              let apiData = {
                iSRATSPID:String(data.GridRowData[k].iSRATSPID), ServiceID:String(data.GridRowData[k].ServiceID),TripRequestStatus:tripStatus, iAssignedVehicleId:
                (typeof data.GridRowData[k].iAssignedVehicleId === "undefined"||data.GridRowData[k].iAssignedVehicleId === null)?'-1':String(data.GridRowData[k].iAssignedVehicleId),
                iScheduleID:(typeof data.GridRowData[k].iScheduleID === "undefined"||data.GridRowData[k].iScheduleID === null)?'-1': String(data.GridRowData[k].iScheduleID),
                AssignedDriverId:(typeof data.GridRowData[k].AssignedDriverId === "undefined"||data.GridRowData[k].AssignedDriverId === null)?'-1':String(data.GridRowData[k].AssignedDriverId),
                ConfirmationNo:confirm,PickupPerson:data.GridRowData[k].PickupPerson,PZONE:data.GridRowData[k].PZONE,
                //IsReturnTrip:(String(data.GridRowData[k].IsReturnTrip).toLowerCase()==="true"?true:false),
                IsReturnTrip: isReturnCanNSRef.current,
                TableSource:(data.GridRowData[k].TableSource ? data.GridRowData[k].TableSource : "FromScheduleTable"), 
                ServiceStatus: data.GridRowData[k].ServiceStatus, iSchDetailID:(typeof data.GridRowData[k].iSchDetailID === "undefined" || data.GridRowData[k].iSchDetailID === null)?'-1':data.GridRowData[k].iSchDetailID,
                CancelTripConf: confirm, CancelTripPickPerson:data.GridRowData[k].PickupPerson, Queue:Queue, iCancelID:cancelReasonRef.current.value, 
                vCancelComments: cancelCommentRef.current.value, iUserID:loginData.iUserID, iAppID:"26"
              };
              let response = await APICom.fetchData("", "TripActions/PerformCancel", "post", { "Content-Type": "application/json" }, apiData, null);
              if(response.data.rowcount <= 0)
              {
                setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'Trip cancellation failed.'});
                setShowCancelAlert(true);
                confirmationFlag = false;
                break;
              }
              else
              {
                confirmationFlag = true;
              }
            }
          } 
          if(confirmationFlag)
          {
            setCancelAlert({...cancelAlert, alertTitle: 'Action Successful', alertMsg:'Trips cancelled successfully.'});
            setShowCancelAlert(true);
            return false;
          }
          
        }
        else
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action Failed', alertMsg:'No Trips were selected, please select a trip and try again.'});
          setShowCancelAlert(true);
          return false;
        }
         
      }
      else if(data.GridRowData.length === 1)
      {
        let Queue = "";
        if ((cancelTripObj.TripRequestStatus && (cancelTripObj.TripRequestStatus.toLowerCase() === "accepted" || 
            cancelTripObj.TripRequestStatus.toLowerCase() === "dispatched" || 
            cancelTripObj.TripRequestStatus.toLowerCase() === "irtpu" ||
            cancelTripObj.TripRequestStatus.toLowerCase() === "atlocation" || 
            cancelTripObj.TripRequestStatus.toLowerCase() === "pickedup"))
            && (cancelTripObj.TableSource && cancelTripObj.TableSource !== "FromScheduleTable"))
            {
              Queue = "InProgress";
            }
        else if (cancelTripObj.TableSource && cancelTripObj.TableSource === "FromScheduleTable"){
          Queue = "Scheduled";
        }
        else{
          Queue = (cancelTripObj.TableSource ? "OnDemand" : "Scheduled");
        }
  
        cancelTripObj.IsReturnTrip = (!chkReturnTripRef.current) ? false: chkReturnTripRef.current.checked;
        cancelTripObj["iCancelID"] = cancelReasonRef.current.value;
        cancelTripObj["vCancelComments"] = cancelCommentRef.current.value;
        cancelTripObj["iUserID"] = loginData.iUserID;
        cancelTripObj["Queue"] = Queue;
        cancelTripObj["iAppID"] = "26";

        //Confirmation Section for Return Trip Cancellation
        //----------------------------------------------------------------
        if(String(IsReturnTrip)?.toLowerCase() === "true")
        {  
          if(promptForReturnCanNS){
            const userConfirmed = await waitForUserConfirmation("Do you want to cancel the return trip");

            if (!userConfirmed) return;
            
            if(isReturnCanNSRef.current === true){
              cancelTripObj.IsReturnTrip = true;
            }
            else if(isReturnCanNSRef.current === false){
              cancelTripObj.IsReturnTrip = false;
            }
          }
          else{
            if(cancelTripObj.IsReturnTrip === true){
              const userConfirmed = await waitForUserConfirmation("There is a return trip of this rider, Please take care of that manually.");

              if (!userConfirmed) return;
              cancelTripObj.IsReturnTrip = false;
            }
          }
          //----------------------------------------------------------------
          //Confirmation Section for Return Trip Cancellation
        }

        let response = await APICom.fetchData("", "TripActions/PerformCancel", "post", { "Content-Type": "application/json" }, cancelTripObj, null);
        let result = response.data;
        if(Number(result.rowcount) > 0)
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action Successful', alertMsg:'Trip cancelled successfully.'});
          setShowCancelAlert(true);
          notifyParent(cancelTripObj?.ConfirmationNo);
        
          return false;
        }
        else
        {
          setCancelAlert({...cancelAlert, alertTitle: 'Action failed', alertMsg:'Trip cancellation failed.'});
          setShowCancelAlert(true);
          return false;
        }
      }
      
    }
    catch(err){console.log(err);}
    
  };

  const notifyParent = (confirmationNumber) => {
    try {
      if(confirmationNumber){
        data.onActionPerformed(confirmationNumber);
      }
    } catch (error) {
      
    }
  }

  const handleCancelDialogClose = () => {
    data.setShowCancel(false);
    // UnMountCancelTripComponent();
  };

const handleFilteringConfirmNum = (e)=>{
  try{
    let elements = document.getElementsByClassName('TripsInfoList');
    
    for(var k = 0; k < elements.length; k++)
    {
        if(!elements[k].children[1].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[k].style.display = "none";
        }
        else
        {
          elements[k].style.display = "table-row";
        }
    }
  }
  catch(err){console.log(err);}
};

const handleFilteringPUPerson = (e)=>{
  try{
    let elements = document.getElementsByClassName('TripsInfoList');

    for(var k = 0; k < elements.length; k++)
    {
        if(!elements[k].children[2].textContent.toLowerCase().includes(e.target.value.toLowerCase()))
        {
          elements[k].style.display = "none";
        }
        else
        {
          elements[k].style.display = "table-row";
        }
    }
  }
  catch(err){console.log(err);}
  
};

const handleSelectionChange = (index, confirmation, selection)=>{
  try{
    setTripSelection(prevState=>{
      const newState = {...prevState};
      newState[index][confirmation] = selection === true?1:0;
      return newState;
    });
  }
  catch(err){console.log(err);}
};
  ////////////////////////////////////////////////////// CANCEL DIALOG EVENTS /////////////////////////////////////////////////

 ////////////////////////////////////////////////////// CONFIRMATION DIALOG EVENTS /////////////////////////////////////////////
  // const handleConfirmationModelOpen = () => { }

  // const handleConfirmationModalOK = () => {
  //   let msgType = confirmationModal.msgType;
  //   switch (msgType) {
  //     case "pickeduptrip":
  //       // updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       // setForceCancel(true);
  //       break;
  //     case "isreturntrip":
  //       updateCancelTripComponentStateObjects("cancelTripObj", { ...cancelTripObj, IsReturnTrip:"true"});
  //       updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       setShowCancelDialog(true);
  //       break;  
  //     default:
  //       break;
  //   }
  // }

  // const handleConfirmationModalCancel = () =>{
  //   let msgType = confirmationModal.msgType;
  //   switch (msgType) {
  //     case "isreturntrip":
  //       updateCancelTripComponentStateObjects("cancelTripObj", { ...cancelTripObj, IsReturnTrip:"false"});
  //       updateCancelTripComponentStateObjects("confirmationModal", { ...confirmationModal, show:false});
  //       setShowCancelDialog(true);
  //       break;  
  //     default:
  //       setConfirmationModal({...confirmationModal, show:false})
  //       UnMountCancelTripComponent();
  //       break;
  //   }
   
  // }

  ////////////////////////////////////////////////////// CONFIRMATION DIALOG EVENTS /////////////////////////////////////////////
  const handleAlertModalClose = () => {
    setShowCancelAlert(false);
    UnMountCancelTripComponent();
  }
  ////////////////////////////////////////////////////// UnMount Cancel Component ///////////////////////////////////////////////
  const UnMountCancelTripComponent = () => {
    if(data.showCancel)
      {
        data.setShowCancel(false);
        console.log("Cancel component Unmounted!");
      }
  }
  ////////////////////////////////////////////////////// UnMount Cancel Component ///////////////////////////////////////////////

  const handleCancelReturnTripDialogYes = () => {
    try {
       
      confirmationPromptForReturnCanNSAlert?.onConfirm();
    } catch (error) {
      
    }
  }

  const handleCancelReturnTripDialogNo = () => {
    try {
       
      confirmationPromptForReturnCanNSAlert?.onCancel();
    } catch (error) {
      
    }
  }

  const handleCancelReturnTripDialogOK = () => {
    try {
       
      confirmationPromptForReturnCanNSAlert?.onOk();
    } catch (error) {
      
    }
  }
  return (
       <>

        {data.showCancel && <Modal size="lg" centered show={data.showCancel} onHide={handleCancelDialogClose} onShow={OpenCancelDialg} keyboard={true} backdrop="static" animation={true}>
        <Modal.Header  className='cancel_dialog_header_bgcolor mb-0' closeButton>
          <Modal.Title className='cancel_dialog_title_color user-select-none'>Cancel Reason</Modal.Title>
            </Modal.Header>
            <Modal.Body className='user-select-none'>
              <Container>
                
                  {showTripTable ? 
                    <Row className='overflow-auto' style={{height:"150px"}}>
                      <Col className="justify-content-center">
                        <table className="w-100 border border-dark">
                          <thead>
                              <tr className="text-center text-nowrap">
                                  {TableHeaders.map((head, headID) =>{
                                      if(head === "Confirmation#")
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="Confirmation#" onKeyUp={handleFilteringConfirmNum} className="d-block w-100 text-center"/></th>;
                                      }
                                      else if(head === "Pickup Person")
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}<input type="text" placeholder="Name" onKeyUp={handleFilteringPUPerson} className="d-block w-100 text-center"/></th>;
                                      }
                                      else
                                      {
                                        return <th className="border border-dark p-1 user-select-none" key={headID}>{head}</th>;
                                      }
                                  })}
                              </tr>
                          </thead>
                          <tbody>
                              {tripsInfo.map((item, index)=>(
                                  <tr key={index} className="text-center TripsInfoList">
                                    <td className="border border-dark user-select-none"><input checked={TripSelection[index][(item.ConfirmationNo ? item.ConfirmationNo : item["Confirmation #"])]=== 1} onChange={(e)=>{let confirm = (item.ConfirmationNo ? item.ConfirmationNo : item["Confirmation #"]); handleSelectionChange(index, confirm, e.target.checked);}} style={{cursor:"pointer"}} value={index} type="checkbox"/></td>
                                    <td value={(item.ConfirmationNo ? item.ConfirmationNo : item["Confirmation #"])} className="border border-dark user-select-none">{(item.ConfirmationNo ? item.ConfirmationNo : item["Confirmation #"])}</td>
                                    <td value={item.PickupPerson} className="border border-dark user-select-none">{item.PickupPerson}</td>
                                    <td value={(item.TripRequestStatus ? item.TripRequestStatus : "")} className="border border-dark user-select-none">{(item.TripRequestStatus ? item.TripRequestStatus : "")}</td>
                                    <td value={(item.IsReturnTrip !== undefined ? item.IsReturnTrip : false)} className="border border-dark user-select-none"><input checked={(item.IsReturnTrip ? String(item.IsReturnTrip).toLowerCase() === "true" : false)} disabled={true} style={{cursor:"not-allowed"}} type="checkbox"/></td>
                                  </tr>
                              ))}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  :
                  <Row>
                    <Col xs={6} md={3}>
                      <b>Confirmation#: </b>{cancelTripObj.CancelTripConf}
                    </Col>
                    <Col xs={6} md={5}>
                      <b>Pickup Person: </b>{cancelTripObj.CancelTripPickPerson}
                    </Col>
                    {data.gridType && data.gridType === 'Standing' ?
                      ""
                      :
                      <Col xs={6} md={4}>
                        <b>{chkReturnTripVisible && <Form.Check type="checkbox" id="chkReturnTrips" label={"Cancel with return leg(s)"} checked={isReturnTripCheckBox} ref={chkReturnTripRef} onChange={handleReturnTripCheckBox} className='cancel_dialog_returncheckbox_color' />}</b>
                      </Col>
                    }
                  </Row>
                  }
                
                <Row>
                  <Col xs={6} md={6}>
                  {showTripStatus && <Form.Label><b>Status:<span className='cancel_dialog_tripStatus_color'>&nbsp; is {cancelTripObj.TripRequestStatus}, Still want to Cancel?</span></b></Form.Label>}
                  </Col>
                  <Col xs={6} md={2}>
                      &nbsp;
                  </Col>
                  <Col xs={6} md={4}>
                      &nbsp;
                  </Col>
                </Row>
              </Container>
              <Form>
              
                <Form.Group className="mb-2 cancel_dialog_reason_indent" controlId="exampleForm.ControlInput1">
                  <Form.Label><b>Reason</b></Form.Label>
                  <Form.Select aria-label="Default select example" onChange={handleCancelReasonChange} ref={cancelReasonRef}>
                    {cancelReasons.map(({ id, name }, index) => <option key={id} value={id} >{name}</option>)} 
                  </Form.Select>
                </Form.Group>
                <Form.Group className="mb-0 cancel_dialog_reason_indent" controlId="exampleForm.ControlTextarea1">
                  <Form.Label><b>Any Comments</b></Form.Label>
                  <Form.Control as="textarea" rows={2} ref={cancelCommentRef} />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button className='cancel_btn_ok' onClick={handleCancelDialogOK}>
                OK
              </Button>
              <Button variant="secondary" onClick={handleCancelDialogClose}>
                Cancel
              </Button>
            </Modal.Footer>
      </Modal> }

       { showCancelAlert && <Modal backdrop="static" centered show={showCancelAlert} onHide={handleAlertModalClose} animation={true}>
        <Modal.Header className='cancel_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
          <Modal.Title className='cancel_dialog_title_color'>{cancelAlert.alertTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body><b>{cancelAlert.alertMsg}</b></Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAlertModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>}

      
      {showConfirmationPromptForReturnCanNS && 
      <Modal size="sm" centered show={showConfirmationPromptForReturnCanNS}  keyboard={true} backdrop="static" animation={true}>
        <Modal.Header  className='cancel_dialog_header_bgcolor mb-0'>
          <Modal.Title className='cancel_dialog_title_color user-select-none'>Warning:</Modal.Title>
        </Modal.Header>
        <Modal.Body className='user-select-none'>
          <Container>
          <b>{confirmationPromptForReturnCanNSAlert.alertMsg}</b>
          </Container>
        </Modal.Body>
          {promptForReturnCanNS &&
            <Modal.Footer>
              <Button className='cancel_btn_ok' onClick={handleCancelReturnTripDialogYes}>
                Yes
              </Button>
              <Button variant="secondary" onClick={handleCancelReturnTripDialogNo}>
                No
              </Button>
              <Button variant="secondary" onClick={ ()=> {setShowConfirmationPromptForReturnCanNS(false)}}>
                Close
              </Button>
            </Modal.Footer>
          }
          {!promptForReturnCanNS && 
            <Modal.Footer>
              <Button className='cancel_btn_ok' onClick={handleCancelReturnTripDialogOK}>
                Ok
              </Button>
           </Modal.Footer>}
      </Modal>}

      {/* {confirmationModal.show? <ConfirmationModal options={confirmationModal} onOpen={handleConfirmationModelOpen} onCancel={handleConfirmationModalCancel} onOk={handleConfirmationModalOK}  /> : ""} */}
      </>
       
      );
};


export default CancelTrip;